export default __webpack_public_path__ + "static/media/Creative Garments Private Limited .1adb7c05.jpg";